import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const columnFilterSlice = createSlice({
    name: "column-filter",
    initialState,
    reducers: {
        setFilters: (_, action) => {
            return action.payload;
        },
    },
});

const { reducer, actions } = columnFilterSlice;

export const { setFilters } = actions;
export default reducer;
